export { default } from './ThumbnailControlPanel';
